
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { goAccessErr, setToken } from "@/modular/Session";

export default defineComponent({
    name: "Startup",
    components: {},
    setup() {
        const router = useRouter();
        return {
            router,
        };
    },
    async mounted() {
        const query = useRoute().query;

        if (query.tenantId) {
            localStorage.setItem('tenantId', (query.tenantId) as string);
        }

        if (query.tokenCode) {
            // 通过code获取token
            const tokenVifsi = await setToken(query.tokenCode as string);
            if (tokenVifsi == true) {
                this.go();
                return;
            }
        }else{
            goAccessErr();
            throw '授权登录异常，可能用户被禁用或者删除';
        }
        // this.isAppInit = await reSessionUser();
        // this.go();
    },
    methods: {
        go() {
            const url = localStorage["loginRedirect"] || "gy/home";
            this.router.replace(url);
        },
    },
    data() {
        return {
            isAppInit: false,
        };
    },
});
